import { RouteConfig } from 'vue-router';
import { permissionDashboard, checkInstitution } from '../Middleware/permission/Dashboard';
import { multiGuard } from '../Middleware/MultiGuard';

import DashboardPage from '@/pages/Dashboard/Dashboard.vue';

export const NAME_ROUTES_DASHBOARD = {
  DASHBOARD: 'Dashboard'
};

export const Dashboard: Array<RouteConfig> = [
  {
    path: '/dashboard',
    component: () => import('@/layouts/Default/index.vue'),
    children: [
      {
        path: '',
        name: NAME_ROUTES_DASHBOARD.DASHBOARD,
        component: DashboardPage,
        beforeEnter: multiGuard([checkInstitution, permissionDashboard]),
        meta: { 
          title: 'Dashboard'
        }
      }
    ]
  }
];
